<template>
  <div class="page--lms_dashboard">
    <!-- <LMSDashboardConfig/> -->
    <!-- <div class="cp_action_popup" :class="{ 'close': !selected_cp}">
      <div class="overlay" @click="selected_cp = false"></div>
      <div class="content">
        <div class="button stop" @click="stopChargingSession">
          <fa :icon="['far','stop-circle']" size="3x"/>
          <div class="label">{{ $t("button.stop_charging") }}</div>
        </div>
        <div class="divider"></div>
        <div class="button detail" @click="goDetail">
          <fa :icon="['fas','charging-station']" size="3x"/>
          <div class="label">{{ $t("button.go_detail") }}</div>
        </div>
        <div class="divider"></div>
        <div class="button restart">
          <fa :icon="['fas','power-off']" size="3x"/>
          <div class="label">{{ $t("button.reboot") }}</div>
        </div>
      </div>
    </div> -->
    <Popup ref="popup">
      <ApiViewDetailsModal :setting="$setting.crud['cp_sessions'].view" namespace="cp_sessions" v-if="selected_cp"
      :data="{
        session_id: lms_info.cps[selected_cp].charge.session_id,
        cp_id: {
          cp_no: selected_cp
        },
      }"/>
    </Popup>
    <div class="overlay" @click="selected_cp = false" v-if="selected_cp"></div>
    <div class="disconnected-wrap" v-if="connection_status == 'disconnected'">
      <div class="message"></div>
      <div class="action-wrap">
        <el-button @click="connect">{{ $t("button.reconnect") }}</el-button>
      </div>
    </div>
    <div class="content">
      <!-- <div class="mode">
        <div class="value">{{  $t(`lms.mode.${lms_info.mode.toLowerCase()}`) }}</div>
        <div class="label">{{ $t("label.mode") }}</div>
        <div class="orig">({{ lms_info.mode }})</div>
      </div> -->
      <div class="loc" v-for="loc in Object.keys(lms_info.relation.loc)" :key="loc">
        <div class="header">
          <div class="name" v-show="Object.keys(lms_info.relation.loc).length > 0">{{ lms_info.cp_locs[loc].name }}</div>
          <div class="mode" v-if="lms_info.profile.location.hasOwnProperty(loc) && lms_info.profile.location[loc].mode!==null">
            <div class="value">{{  $t(`lms.mode.${lms_info.profile.location[loc].mode.toLowerCase()}`) }}</div>
            <div class="label">{{ $t("label.mode") }}</div>
            <div class="orig">({{ lms_info.profile.location[loc].mode }})</div>
          </div>
        </div>
        <div class="zone-wrapper">
          <div class="zone" v-for="zone in Object.keys(lms_info.relation.loc[loc].zone)" :key="zone">
            <div class="header">
              <div class="name">{{ lms_info.cp_zones[zone].name_chi }}</div>
              <div class="meta">
                <div class="current">
                  <div class="meter">
                    <div class="value">{{ getZoneMeterCurrent(lms_info.cp_zones[zone].id) }}</div>
                    <div class="unit">A</div>
                  </div>
                  <div class="using">
                    <div class="value">{{ getZoneChargingCurrent(lms_info.cp_zones[zone].id) }}</div>
                    <div class="unit">A</div>                    
                  </div>
                  <div class="total" v-if="lms_info.profile.location[loc].zone.hasOwnProperty(zone)">
                    <div class="value">{{ lms_info.profile.location[loc].zone[zone].zone_max_available_current }}</div>
                    <div class="unit">A</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cp-wrapper">
              <div class="cp" v-for="cp in lms_info.relation.loc[loc].zone[zone].cp" :key="cp" :class="[status[cp], { 'selected': selected_cp == cp }]">
                <div class="inner-wrap" @click="toggleCp(cp)">
                  <div class="header">
                    <div class="name-wrapper">
                      <div class="inner-wrap">
                        <div class="name">{{ lms_info.cps[cp].name }}</div>
                        <div class="divider"></div>
                        <div class="cp_no">{{ cp }}</div>
                      </div>
                      <div class="distributed_current" v-if="typeof lms_info.cps[cp].charge.distributed_current == 'number'">({{ lms_info.cps[cp].charge.distributed_current }}A)</div>
                    </div>
                    <div class="status">
                      <div class="icon" :class="status[cp]"></div>
                      <div class="label">{{ cp_status[cp] != null ? $t(`lms.status.${cp_status[cp]}`) : "N/A" }}</div>
                      <div class="queueing_pos" v-if="status[cp] == 'queueing' && lms_info.cps[cp].queue.queueing_pos">({{ lms_info.cps[cp].queue.queueing_pos }})</div>
                    </div>
                  </div>
                  <div class="content" v-if="status[cp] == 'charging'">
                    <div class="content-wrap">
                      <div class="data-wrap" v-if="lms_info.cps[cp].charge.curr_data">
                        <div class="data">
                          <div class="label">{{ $t("field.cp_requests.ampere") }}</div>
                          <div class="wrap">
                            <div class="value">{{ lms_info.cps[cp].charge.curr_data.current }}</div>
                            <div class="unit">A</div>
                          </div>
                        </div>
                        <div class="data">
                          <div class="label">{{ $t("field.cp_requests.energy") }}</div>
                          <div class="wrap">
                            <div class="value">{{ lms_info.cps[cp].charge.curr_data.meter/1000 }}</div>
                            <div class="unit">kWh</div>
                          </div>
                        </div>
                        <div class="data">
                          <div class="label">{{ $t("field.cp_requests.voltage") }}</div>
                          <div class="wrap">
                            <div class="value">{{ lms_info.cps[cp].charge.curr_data.voltage }}</div>
                            <div class="unit">V</div>
                          </div>
                        </div>
                      </div>
                      <div class="field-wrap">
                        <div class="field" v-if="lms_info.cps[cp].charge.start_tran_at">
                          <div class="label">{{ $t("lms.label.start_tran_at") }}</div>
                          <div class="value">{{ $moment(lms_info.cps[cp].charge.start_tran_at).format($conf.date.SHORT) }}</div>
                        </div>
                        <div class="field" v-if="lms_info.cps[cp].queue.start_queueing_at">
                          <div class="label">{{ $t("lms.label.start_queueing_at") }}</div>
                          <div class="value">{{ $moment(lms_info.cps[cp].queue.start_queueing_at).format($conf.date.SHORT) }}</div>
                        </div>
                        <div class="field" v-if="lms_info.cps[cp].charge.select_time">
                          <div class="label">{{ $t("lms.label.select_time") }}</div>
                          <div class="value" v-html="getFormatTime(lms_info.cps[cp].charge.select_time*60)"></div>
                        </div>
                        <div class="field" v-if="lms_info.cps[cp].charge.start_tran_at && lms_info.cps[cp].charge.select_time">
                          <div class="label">{{ $t("lms.label.charging_end_at") }}</div>
                          <div class="value">{{ $moment(lms_info.cps[cp].charge.start_tran_at).add(lms_info.cps[cp].charge.select_time, 'minutes').format($conf.date.SHORT) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tool-wrap" :class="{ 'close': selected_cp != cp}">
                  <div class="inner-wrap">
                    <div class="row">
                      <div class="button stop" @click="stopChargingSession" :class="{ 'disabled': !selected_cp || Object.keys(lms_info.cps[selected_cp].charge).length == 0 }">
                        <fa :icon="['far','stop-circle']"/>
                        <div class="label">{{ $t("button.stop_charging") }}</div>
                      </div>
                      <div class="divider"></div>
                      <div class="button restart" @click="restartCp">
                        <fa :icon="['fas','power-off']"/>
                        <div class="label">{{ $t("button.reboot") }}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="button detail" @click="goDetail">
                        <fa :icon="['fas','charging-station']"/>
                        <div class="label">{{ $t("button.go_detail") }}</div>
                      </div>
                      <div class="divider"></div>
                      <div class="button detail" @click="viewChargingDetail" :class="{ 'disabled': !selected_cp || Object.keys(lms_info.cps[selected_cp].charge).length == 0 }">
                        <fa :icon="['fas','charging-station']"/>
                        <div class="label">{{ $t("button.show_charging_detail") }}</div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar" :class="{ 'in': selected_cps.length > 0 }">
      <div class="inner-wrap">
        <div class="selected">
          <div class="cp" v-for="cp in selected_cps" :key="cp">{{ cp }}</div>
        </div>
        <div class="action">

        </div>
      </div>
    </div>
    <div class="block" style="height:150px" v-show="selected_cps.length > 0"></div>
  </div>
</template>

<script>
// import LMSDashboardConfig from "./modules/LMSDashboardConfig";
import ApiViewDetailsModal from "@/views/crud/modules/ApiViewDetailsModal";
import {connect} from "echarts/lib/echarts";

export default {
  components: {
    // LMSDashboardConfig,
    ApiViewDetailsModal
  },
  async mounted() {
    this.gconf = window.gconf;
    console.log('mounted')
    this.connect();
    let refresh_interval = this.gconf.websocket.dashboard.refresh_interval && this.gconf.websocket.dashboard.refresh_interval > 500 ? this.gconf.websocket.dashboard.refresh_interval : 5000;
    setInterval(this.connect, refresh_interval);
    setInterval(this.fetchData, refresh_interval);
  },
  methods: {
    onMessage(event) {
      let data = JSON.parse(event.data);
      Object.keys(data.cp).map(cp_no=>{
        let update = data.cp[cp_no];
        switch(data.type) {
          case "status_update":
            this.statusUpdate(update)
            break;
        }
      });
      this.$forceUpdate();
      console.log(data);
      console.log(data.cp);
    },
    fetchData() {
      if(this.leave) return;
      this.connection.send(JSON.stringify({
        type: "all_status_update"
      }));
    },
    goDetail() {
      window.open(`/cps/${this.lms_info.cps[this.selected_cp].cp_id}`);
    },
    restartCp() {
      this.selected_cp = false;
    },
    statusUpdate(update) {
      this.status[update.cp_no] = update.status;
      this.cp_status[update.cp_no] = update.cp_status;
      console.log("update: ",update);
      // reset charge data if not charging
      if(update.status == "charging") {
        this.lms_info.cps[update.cp_no].queue = {};
      }else {
        this.lms_info.cps[update.cp_no].charge = {};
      }
      if(update.queueing_pos) {
        this.lms_info.cps[update.cp_no].queue.queueing_pos = update.queueing_pos;
      }
      if(update.start_queueing_at) {
        this.lms_info.cps[update.cp_no].queue.start_queueing_at = update.start_queueing_at;
      }
      if(typeof update.distributed_current != "undefined") {
        this.lms_info.cps[update.cp_no].charge.distributed_current = Math.floor(update.distributed_current);
      }
      if(update.start_tran_at) {
        this.lms_info.cps[update.cp_no].charge.start_tran_at = update.start_tran_at;
      }
      if(update.select_time) {
        this.lms_info.cps[update.cp_no].charge.select_time = update.select_time;
      }
      if(update.session_id) {
        this.lms_info.cps[update.cp_no].charge.session_id = update.session_id;
      }
      if(update.curr_data) {
        this.lms_info.cps[update.cp_no].charge.curr_data = update.curr_data;
      }
    },
    async connect() {
      if(this.connection_status == "connected") return;
      if(this.leave) return;
      await this.$axios.get(`lms_info`).then(res=>{
        this.lms_info = res.data.response.lms_info;
        Object.keys(this.lms_info.cps).map(cp=>{
          this.status[cp] = "disconnected";
          this.lms_info.cps[cp].charge = {};
          this.lms_info.cps[cp].queue = {};
        });
        return true;
      }).catch(err=>{
        return false;
      });
      try{
        // this.connection = new WebSocket(`${this.$conf.api.BASE_WS_URL}/lms/status`,"ocpp1.6" );
          console.log('try to connect to '+ this.webSocketUrl);
          var _this = this;
          this.connection = new WebSocket(this.webSocketUrl);
          // console.log(connection.readyState)

          // console.log(this.connection.send("a"));
          this.connection_status = "connected";
        let vm = this;
        this.connection.onopen = function (event) {
          console.log("opened");
          vm.connection_status = "connected";
        };
        this.connection.onmessage = function(event) {
          vm.onMessage(event);
        };
        this.connection.onclose = function (event) {
          console.log("closed");
          vm.connection_status = "disconnected";
          vm.status = {};
          vm.cp_status = {};
        }
        this.connection.onerror = function (event) {
            // _this.webSocketUrl = `${this.$conf.api.BASE_WS_URL}/lms/status`;
            console.log('retry to connect to '+ _this.webSocketUrl);
            vm.$notify.error({
            title: 'Error',
            message: 'Websocket Error',
            position: 'top-left'
          });
          vm.connection_status = "disconnected";
          // vm.connected = false;
          vm.status = {};
          vm.cp_status = {};
        }
      }catch(err) {
          this.$notify.error({
          title: 'Error',
          message: 'Websocket Connection Error',
          position: 'top-left'
        });
          // _this.webSocketUrl = `${this.$conf.api.BASE_WS_URL}/lms/status`;
          console.log('retry to connect to '+ this.webSocketUrl);
      }
    },
    getZoneChargingCurrent(zone_id) {
      return Object.keys(this.lms_info.cps).map(cp_no=>{
        // if(this.status.hasOwnProperty(cp_no)) return 0;
        if(this.status[cp_no] != "charging") return 0;
        let cp = this.lms_info.cps[cp_no];
        console.log("zone_id: ", zone_id);
        console.log("cp.zone_id: ", cp.zone_id);
        return cp.zone_id == zone_id && cp?.charge?.distributed_current  ? cp.charge.distributed_current : 0;
      }).reduce((a,b)=>a+b,0);
    },
    getZoneMeterCurrent(zone_id) {
      return Object.keys(this.lms_info.cps).map(cp_no=>{
        // if(this.status.hasOwnProperty(cp_no)) return 0;
        if(this.status[cp_no] != "charging") return 0;
        let cp = this.lms_info.cps[cp_no];
        console.log("zone_id: ", zone_id);
        console.log("cp.zone_id: ", cp.zone_id);
        return cp.zone_id == zone_id && cp?.charge?.curr_data?.current  ? cp.charge.curr_data.current : 0;
      }).reduce((a,b)=>a+b,0);
    },
    toggleCp(cp) {
      if(!this.cp_status.hasOwnProperty(cp)) return;
      this.selected_cp = cp;

      // this.connection.send(JSON.stringify({
      //   type: "stop_charging_session",
      //   cpNo: cp
      // }));
      // let index = this.selected_cp.indexOf(cp);
      // if(index != -1) {
      //   this.selected_cp.splice(index, 1);
      // }else {
      //   this.selected_cp.push(cp);
      // }
    },
    async stopChargingSession() {
      if(!this.selected_cp) return;
      if(Object.keys(this.lms_info.cps[this.selected_cp].charge).length == 0) return;
      let cpNo = this.selected_cp;
      this.selected_cp = false;
      let confirm = await this.$confirm(this.$tc("message.sure_to_stop_charging_session", null, { cp_no: cpNo }))
        .then(()=>{
          return true;
        })
        .catch(()=>{
          this.selected_cp = cpNo;
          return false;
        });
      if(!confirm) return;
      this.connection.send(JSON.stringify({
        type: "stop_charging_session",
        cpNo: cpNo
      }));
      this.selected_cp = false;
    },
    viewChargingDetail() {
      if(!this.selected_cp) return;
      if(Object.keys(this.lms_info.cps[this.selected_cp].charge).length == 0) return;
      this.$refs.popup.show();
    }
  },
  beforeDestroy() {
    this.leave = true;
    if(this.connection != null) {
      this.connection.close();
    }
  },
  data() {
    return {
      leave: false,
      selected_cp: false,
      connection_status: "unknown",
      gconf: {},
      lms_info: {
        mode: "unknown",
        cp_locs: {},
        cp_zones: {},
        cps: {},
        relation: {
          loc: {}
        },
        profile: {
          location: {}
        }
      },
      status: {},
      cp_status: {},
      connection: null,
      selected_cps: [],
        // webSocketUrl: 'ws://hit.cstl.com.hk/portal/api/lms/status',
      webSocketUrl: `${this.$conf.api.BASE_WS_URL}/lms/status`,
    }
  }
}
</script>

<style lang="scss">
.page--lms_dashboard{
  position: relative;
  .overlay{
    z-index: 1001;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }
  .cp_action_popup{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    visibility: visible;
    transition: opacity .2s ease-in-out;
    &.close{
      opacity: 0;
      visibility: hidden;
    }
    .overlay{
      z-index: 1001;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,.5);
    }
    .content{
      z-index: 1002;
      background: white;
      border-radius: 5px;
      min-height: 70px;
      width: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      .button{
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        align-items: center;
        justify-content: center;
        height: 100%;
        transition: background .2s ease-in-out;
        user-select: none;
        min-height: 70px;
        cursor: pointer;
        &.stop{
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          color: #ab0000;
        }
        &.detail{
          color: #333;
        }
        &.restart{
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          color: #c66400;
        }
        &:hover{
          background: #ccc;
        }
      }
      .divider{
        width: 1px;
        height: 65px;
        background: #aaa;
      }
    }
  }
  & > .status{
    height: 20px;
    width: 20px;
    border-radius: 50%;
    &.disconnected{
      background: #999;
    }
    &.connected{
      background: #3fff00;
    }
    &.reconnecting{
      background: orange;
    }
  }
  .disconnected-wrap{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: #999;
    opacity: .5;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .content{
    // min-width: 800px;
    .content-wrap{
      display: flex;
      .data-wrap{
        order: 2;

        // display: flex;
        // margin-bottom: 10px;

        .data{
          margin-top: 5px;
          line-height: 1.5em;
          .wrap{
            display: flex;
            // width: 33.3333%;
            // justify-content: center;
            
            &:not(:last-child) {
              // border-right: 1.5px solid #ccc;
            }
            .unit{
              margin-left: 2px;
            }
          }
        }
      }
      .field-wrap{
        order: 1;
        width: 50%;
      }
    }
    .mode{
      display: flex;
      // margin-bottom: 10px;
      justify-content: flex-end;
      .orig{
        margin-left: 5px;
      }
    }
    .loc{
      margin-bottom: 20px;
      // background: #f3f7ff;
      & > .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: small;
        background:var(--general-header-bg);
        border: 1px solid var(--layout-border-color);
        padding: 5px;
        .name{
        }
      }
      .zone-wrapper{
        display: grid;
        grid-template-columns: repeat(3,minmax(120px, 1fr));
        margin-top: 5px;
        grid-gap: 10px;
        .zone{
          padding: 10px;
          background: #F5F5F5;
          & > .header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .current{
              // display: flex;
              // align-items: center;
            }
            .value,
            .unit,
            .using,
            .total{
              display: inline-block;
            }
            .using,
            .total{
              &::before{
                content: "/";
                margin: 0 3px;
                font-size: 14px;
              }
            }
            .name{
              font-size: small;
            }
            .unit{
              font-size: xx-small;
            }
            .meter{
              display: inline-block;
            }
            .using{
              display: inline-block;
              // .data-wrap,
              // .meter-data{
              //   display: inline-block;
              // }
              .data-wrap{
                margin-right: 2px;
              }
              .meter-data{
                zoom: .85;
              }
              .value{
                font-size: 20px;
              }
            }
            .total{
              zoom: .85;
            }
          }
          .cp-wrapper{
            // display: grid;
            // grid-template-columns: repeat(5, 1fr);
            grid-gap: 10px;
            margin-top: 5px;
            .cp{
              // margin: 0px 20px;
              margin-bottom: 5px;
              // width: 200px;
              background: white;
              // box-shadow: 0 1px 5px #ddd;
              // border: 1px solid #e3e3e3;
              border-radius: 5px;
              
              transition: opacity .3s ease-in-out, background .2s ease-in-out;
              position: relative;
              &.disconnected{
                opacity: .2;
              }
              .header{
                display: flex;
                justify-content: space-between;
                padding: 5px 10px;
                .name-wrapper{
                  display: flex;
                  align-items: center;
                  font-size: x-small;
                  .inner-wrap{
                    display: flex;
                    align-items: center;
                    max-width: 170px;
                    .divider{
                      width: 1px;
                      height: 15px;
                      background: #ccc;
                      margin-left: 5px;
                      margin-right: 15px;
                    }
                    .name,
                    .cp_no{
                      text-overflow: ellipsis;
                      overflow: hidden;
                      white-space: nowrap;
                    }
                    .name{
                      width: 60px;
                    }
                    .cp_no{

                    }
                  }
                  .distributed_current{
                    margin-left: 3px;
                  }
                }
                .status{
                  font-size: x-small;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .icon{
                    width: 10px;
                    height: 10px;
                    background: #AAA;
                    &.available,
                    &.Available{
                      background: #3fff00;
                    }
                    &.charging{
                      background: orange;
                    }
                    &.queueing{
                      background: royalblue;
                    }
                    &.SuspendedEV,
                    &.SuspendedEVSE{
                      background: lightskyblue;
                    }
                  }
                  .label{
                    margin-left: 2px;
                    min-width: 40px;
                  }
                }
              }
              .content{
                font-size: x-small;
                margin-top: 10px;
                padding: 0 10px;
                padding-bottom: 5px;
                .field{
                  // display: flex;
                  line-height: 1.5em;
                  margin-top: 5px;
                  .label{
                    margin-right: 5px;
                  }
                  & > .value{
                    margin-left: 5px;
                    .wrap{
                      display: inline-block;
                      .value,
                      .unit{
                        display: inline-block;
                      }
                    }
                  }
                }
              }
              &:not(.disconnected){
                cursor: pointer;
              }
              &.selected{
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
              }
              &:not(.disconnected):not(.selected):hover{
                background: #e4e4e4;
              }
              .tool-wrap{
                bottom: calc(-27px * 2);
                // min-width: 250px;
                left: 0;
                position: absolute;
                width: 100%;
                z-index: 1002;
                opacity: 1;
                visibility: visible;
                transition: opacity .2s ease-in-out;
                .inner-wrap{
                  // display: flex;
                  height: 100%;
                  background: #e2e2e2;
                  // padding: 2px 5px;
                  border-bottom-left-radius: 5px;
                  border-bottom-right-radius: 5px;
                  .row{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 27px;
                    &:last-child{
                      :first-child{
                        border-bottom-left-radius: 5px;
                      }
                      :last-child{
                        border-bottom-right-radius: 5px;
                      }
                    }
                  }
                  .button{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: small;
                    user-select: none;
                    width: 100%;
                    max-width: 50%;
                    height: 100%;
                    transition: background .2s ease-in-out;
                    .label{
                      margin-left: 2px;
                    }
                    &.stop{
                      color: #ab0000;
                    }
                    &.detail{
                      color: #333;
                    }
                    &.restart{
                      color: #c66400;
                    }
                    &:not(.disabled):hover{
                      background: #ccc;
                    }
                    &.disabled{
                      cursor: not-allowed;
                      opacity: .2;
                    }
                  }
                  .divider{
                    width: 1px;
                    height: 15px;
                    background: #aaa;
                  }
                }
                &.close{
                  visibility: hidden;
                  opacity: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .footer-bar{
    position: fixed;
    bottom: -150px;
    right: 17px;
    height: 150px;
    width: calc(100% - 140px - 17px);
    
    max-width:inherit;
    transition: bottom .2s ease-in-out;
    .inner-wrap{
      margin: 0 10px;
      border-radius: 5px;
      padding: 20px;
      background: white;
      box-shadow: 0px 0px 5px #ccc;
      height: 100%;
      .selected{
        display: flex;
        flex-wrap: wrap;
        .cp{
          font-size: small;
          // margin: 0 5px;
          margin-left: 5px;
          margin-bottom: 5px;
          padding: 1px 7px;
          border-radius: 5px;
          background: #dadada;
        }
      }
    }
    &.in{
      bottom: 0px;
    }
  }
}
</style>